import { AppRoutes } from './router';
import { ScrollManager } from './ScrollManager';

/**
 * The app without a router: main.tsx wraps it in BrowserRouter, entry-server.tsx in
 * StaticRouter for build-time prerendering. Keep it free of browser-only globals at
 * render time (window, document, navigator) so it renders the same on both.
 * Each section (Travo Labs root, /travo, /membersheep) brings its own layout and providers.
 */
function App() {
  return (
    <>
      <ScrollManager />
      <AppRoutes />
    </>
  );
}

export default App;
